<template>
  <div>
    <b-card>
      <titleSection
        title="Documentos requeridos"
        subtitle="En formato digital y a color."
        icon="FileTextIcon"
      />
      <div>
        <h5 class="text-primary mb-75 mt-2">
          <b>Documentación</b>
        </h5>
        <b-card-text class="mr-5 ml-1">
          <ul>
            <li
              v-for="(requisito, index) in requisitos"
              :key="index"
            >{{ requisito.nombre }}</li>
          </ul>
        </b-card-text>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import { getData } from '@core/utils/http/general'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    titleSection,
    BCard,
    BCardText,
  },
  props: {
    plan: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props) {
    const requisitos = ref([])
    const toast = useToast()
    const documentacion = () => {
      requisitos.value = []
      getData({ action: 36, q: props.plan })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) requisitos.value = response.data.data
        })
        .catch(err => toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición',
            text: err,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 }))
    }
    onMounted(() => {
      documentacion()
    })
    watch(() => props.plan, () => {
      documentacion()
    })

    return {
      requisitos,
    }
  },

}
</script>
